import { cn } from '@autone/ui';
import { type HTMLAttributes } from 'react';
interface CoreDropdownWrapperProps extends HTMLAttributes<HTMLDivElement> {
  label?: string;
  infoText?: string;
}

export const CoreDropdownGridLayout = ({
  className,
  children,
  ...props
}: CoreDropdownWrapperProps) => (
  <div className={cn('grid grid-cols-2 gap-x-2 gap-y-4', className)} {...props}>
    {children}
  </div>
);

interface CoreDropdownSectionHeaderLayoutProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  headerText?: string;
  badge?: React.ReactNode;
}

export const CoreDropdownSectionHeaderLayout = ({
  className,
  headerText,
  badge,
  ...props
}: CoreDropdownSectionHeaderLayoutProps) => (
  <div className={cn('flex flex-row justify-between', className)} {...props}>
    <p className="text-base font-medium">{headerText}</p>
    {badge}
  </div>
);
